import { useFormik } from 'formik'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getUserListPQRS, sendUserPQRS } from '../../actions/userActions'
import CreatePqrsView from '../../containers/Pqrs/CreatePqrs'
import * as Yup from 'yup';

const CreatePqrs = () => {
    const dispatch = useDispatch()
    const { listPQRSUser } = useSelector(state => state.userInfo)

    useEffect(() => {
        dispatch(getUserListPQRS())

        return () => {

        }
    }, [])

    const validationSchema = Yup.object().shape({
        type: Yup.string().required('Requerido'),
        description: Yup.string().required('Requerido'),
        petitionSubject: Yup.string().required('Requerido'),
    });
    const formkik = useFormik({
        initialValues: {
            type: "petition",
            description: "",
            petitionSubject: "",
        },
        onReset: () => {


        },
        validationSchema: validationSchema,
        onSubmit: (values, { resetForm }) => {

            dispatch(sendUserPQRS(values, () => { resetForm() }))
        }
    })
    return (
        <CreatePqrsView formik={formkik} listPQRSUser={listPQRSUser} />
    )
}

export default CreatePqrs